import { useQuery } from '@tanstack/react-query';

import { getTaxDocumentsForYear } from '@arrived/api_v2';
import { AccountId, TaxDocumentList } from '@arrived/models';

import { MAX_STALE_TIME, UseQueryOptions } from '../queries.utils';
import { taxDocumentKeyFn } from './taxDocuments.keys';

export function useGetTaxDocumentQuery(
  year: number,
  accountId?: AccountId,
  options?: UseQueryOptions<TaxDocumentList>
) {
  return useQuery(taxDocumentKeyFn(accountId!, year), async () => getTaxDocumentsForYear(accountId!, year), {
    ...options,
    enabled: (options?.enabled ?? true) && accountId != null,
    staleTime: options?.staleTime ?? MAX_STALE_TIME,
  });
}
